const PAYMENT_LINK_HISTORY_GETTERS = {
  isLoading: 'paymentLinkHistory/isLoading',
  items: 'paymentLinkHistory/items',
  total: 'paymentLinkHistory/total',
  sort: 'paymentLinkHistory/sort',
  filters: 'paymentLinkHistory/filters',
  search: 'paymentLinkHistory/search',
  range: 'paymentLinkHistory/range',
  selectedStatus: 'paymentLinkHistory/selectedStatus',
  statusCounts: 'paymentLinkHistory/statusCounts',
}

const PAYMENT_LINK_HISTORY_DISPATCHERS = {
  getQueryParams: 'paymentLinkHistory/getQueryParams',
  getPaymentLinksHistory: 'paymentLinkHistory/getPaymentLinksHistory',
  changePage: 'paymentLinkHistory/changePage',
  onSelectSort: 'paymentLinkHistory/onSelectSort',
  onSelectFilter: 'paymentLinkHistory/onSelectFilter',
  onSearch: 'paymentLinkHistory/onSearch',
  setRange: 'paymentLinkHistory/setRange',
  resetFiltersAndSorting: 'paymentLinkHistory/resetFiltersAndSorting',
  resetStore: 'paymentLinkHistory/resetStore',
  onSelectStatus: 'paymentLinkHistory/onSelectStatus',
  onExportToExcel: 'paymentLinkHistory/onExportToExcel',
}

export { PAYMENT_LINK_HISTORY_GETTERS, PAYMENT_LINK_HISTORY_DISPATCHERS }
